import { makeAutoObservable, runInAction } from "mobx";
import BillingService from "../../../services/api/billing-service";
import { rootContainer, TYPE } from "../../../services/container/root";
import { ISbrReceipt } from "./sbr-receipt-request-store";

class LastSBRReceiptStore {
    private _lastReceipt: ISbrReceipt|undefined;
    private _isLoading: boolean = false;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get service(): BillingService {
        return rootContainer.get<BillingService>(TYPE.BillingService);;
    }

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public get companyTaxId(): string | undefined {
        return this._lastReceipt?.company_tax_id;
    }

    public get other(): string | undefined {
        return this._lastReceipt?.other;
    }

    public fetchFreshLatestSbrReceipt() {
        this._lastReceipt = undefined;
        this.load();
    }

    async load() {
        if (this._lastReceipt !== undefined) {
            return;
        }

        this._isLoading = true;
        try {
            const latestSbrReceipt = await this.service.fetchLatestSbrReceipt();
            if (latestSbrReceipt) {
                runInAction(() => {
                    this._lastReceipt = latestSbrReceipt;
                });
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            runInAction(() => {
                this._isLoading = false;
            });
        }
    }
}

export default new LastSBRReceiptStore();